export const UpdateLayerByType = `
    mutation updateLayerByType ($type: String!, $layerName: String!) {
        updateLayerByType (input: {type: $type, layerPatch: {
            layername: $layerName
        }}) {
            layer {
                layername,
                type
            }
        }
    }
`;
